import { SearchResult, SearchResultNetworkModel } from '@norlys-a-s/norlys-play-kmm';

import { SearchResultInfo, SearchResultItem } from '@smart-tv/typings/search';

const { ContentType, CoverIcon } = SearchResultNetworkModel.SearchResultItemNetworkModel;

export const mapSearchResultItem = (item: SearchResult.SearchResultItem): SearchResultItem => ({
  contentId: item.contentId,
  title: item.title ?? null,
  contentType: (item.contentType?.name as SearchResultItem['contentType']) ?? null,
  coverImageUrl: item.coverImageUrl ?? null,
  isSubscriptionOnly: item.coverIcon?.name === 'SUBSCRIPTION',
  isCustomerFavorite: item.isCustomerFavorite,
  providerLogoOverlayImageUrl: item.providerLogoOverlayImageUrl ?? null
});

export const mapSearchResult = (result: SearchResult): SearchResultInfo => ({
  elementCount: result.elementCount,
  results: result.results.asJsReadonlyArrayView().map(mapSearchResultItem),
  suggestions: Array.from(result.suggestions.asJsReadonlyArrayView()),
  resultTitle: result.resultTitle ?? null,
  suggestionTitle: result.suggestionTitle ?? null
});

// Reconstructs the KMM entity needed by addToSearchHistory/removeFromSearchHistory.
export const toKmmSearchResultItem = (item: SearchResultItem): SearchResult.SearchResultItem =>
  new SearchResult.SearchResultItem(
    item.contentId,
    item.title,
    item.contentType === 'SERIES' ? ContentType.SERIES : ContentType.MOVIES,
    item.coverImageUrl,
    item.isSubscriptionOnly ? CoverIcon.SUBSCRIPTION : null,
    item.isCustomerFavorite,
    item.providerLogoOverlayImageUrl
  );

